
"use strict"

// import componentName from './path/to/componentName'
import expand from './components/expand'
import asyncLoadOnScroll from './utility/asyncLoadOnScroll'
import videoLightbox from './components/video'
import logoCarousel from './components/logoCarousel'
import serviceCarousel from './components/serviceCarousel'
import nav from './components/nav'
import tabs from './components/tabs'
import steps from './components/steps'
import mobileNav from './components/mobileNav'
import './components/mobileNavigation'
import podcastCarousel from './components/podcastCarousel'

// import './components/navigation'
import './components/load-row'
import './components/cursor'

import './animations/gsapSetup'
import './animations/headings'
import './animations/navigation'
import './animations/hero'
import './components/newsFilter'



videoLightbox()
logoCarousel()
podcastCarousel()
nav()
tabs()
steps()
mobileNav()
serviceCarousel()

expand('.accordion__button', (open, button, content) => {
	const openClass = 'is-open'
	open ? button.parentNode.classList.add(openClass) : button.parentNode.classList.remove(openClass)
})

document.documentElement.classList.remove('no-js')
document.documentElement.classList.add('js')

// Smooth scroll to anchor links within the page
document.addEventListener('click', function (e) {
	const target = e.target.closest('a[href^="#"]');
	if (target && target.getAttribute('href') !== '#' && target.getAttribute('href') !== '#!') {
		const href = target.getAttribute('href');
		const anchorId = href.slice(1);
		const anchor = document.getElementById(anchorId);
		if (anchor) {
			e.preventDefault();
			anchor.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
			// Optionally update the URL hash without jumping
			history.pushState(null, '', href);
		}
	}
});